module.exports = __webpack_public_path__ + "img/zhifubao.ef93c428.png";